// Single source of truth for FSS bucket S3 keys.
// Kept free of aws-sdk / db imports so the browser bundle (pimento) can
// import it alongside the server packages (smokepit, saltfish). Folder
// derivation reuses the canonical extension classifier in uploadCategories.

import { categorizeExtension, UploadCategory } from "./uploadCategories";

export type UploadFolder = "images/rgb" | "lidar" | "attachments" | "unknown";

const CATEGORY_TO_FOLDER: Record<UploadCategory, UploadFolder> = {
  image: "images/rgb",
  pointcloud: "lidar",
  geometry: "attachments",
  other: "unknown",
};

export function folderForKey(key: string): UploadFolder {
  return CATEGORY_TO_FOLDER[categorizeExtension(key.split(".").pop())];
}

export function getKey({
  key,
  surveyId,
  orderId,
  folder,
}: {
  key: string;
  surveyId: number;
  orderId: number;
  // Callers that always target a fixed folder (e.g. image deletes, order
  // attachments) pass it explicitly; otherwise it is derived from the key.
  folder?: UploadFolder;
}) {
  const resolvedFolder = folder ?? folderForKey(key);

  return `analysis/surveys/s-${surveyId}/o-${orderId}/${resolvedFolder}/${key}`;
}
